<template>
  <v-row class="ma-0">
    <v-avatar
      v-for="(icon, iconIndex) in labels"
      :key="iconIndex"
      tile
      class="mr-4"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <img
            v-if="icon.PictureUrl"
            v-bind="attrs"
            v-on="on"
            :src="icon.PictureUrl"
            :alt="icon.Name"
          />
        </template>
        <span>{{ icon.Name }}</span>
      </v-tooltip>
    </v-avatar>
  </v-row>
</template>

<script>
export default {
  name: 'ProductLabels',
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
